// extracted by mini-css-extract-plugin
module.exports = {"GlobeIcon--white":"globe-icon_GlobeIcon--white__dtq4k","GlobeIcon--black":"globe-icon_GlobeIcon--black__s5MxD"};